import React from 'react';
import { Select } from '@material-ui/core';

interface Props {
  value: luxon.DateTime,
  onChange: (e: React.ChangeEvent<{
    name?: string | undefined;
    value: unknown;
  }>) => void,
  isUnselectedFlightMinutes: boolean
}

/** タクシー・ハイヤー予約画面の時刻のセレクトボックスのコンポーネント。 */
export const SelectFlightMinutes: React.FC<Props> = (props: Props) => {
  /** 「分」部分（0~59までの数値）の配列。 */
  const minutes = Array.from(Array(60).keys())

  const setValue = (v: number) => {
    return v.toString().padStart(2, '0');
  }

  const defaultValue = props.isUnselectedFlightMinutes ? '---' : props.value?.minute;

  return (
    <Select native value={defaultValue} onChange={props.onChange}>
      {props.isUnselectedFlightMinutes && <option value='---'>---</option>}
      {
        minutes.map((m) => {
          return <option value={m} key={`minutes_${m}`}>{setValue(m)}</option>
        })
      }
    </Select>
  );
}

export default SelectFlightMinutes;
